enum MedicareLevyStatus {
  NO_EXCEMPTION, HALF_EXCEMPTION, FULL_EXCEMPTION
};

export default MedicareLevyStatus;
